'use client';

import {CategoryCard} from '@purpose/ui/components/specialized-carousels/CategoryCard';
import {Carousel} from '@purpose/ui/components/carousel';
import {CheckIcon, Plus} from 'lucide-react';
import {colors} from '@purpose/ui/styles/theme/colors';

interface BenefitsCarouselCard {
  logo: string;
  name?: string;
  description?: string;
  subtitle?: string;
  id: number;
  is_request_sent?: boolean;
  organisaton_id?: number;
  is_subscribed?: boolean;
}

interface BenefitsCarouselProps {
  title: string;
  cards: BenefitsCarouselCard[];
  getButtonTitle: (condition: boolean, condition2?: boolean) => string;
  onCardClick?: (id: number | string) => void;
  handleAddSubscription: (id: BenefitsCarouselCard) => () => void;
  buttonIconColor?: string;
  onTitleClick?: () => void;
  loadingIds?: number[];
  renderLastCard?: () => React.ReactNode;
}

const BenefitsCarousel = ({
  title,
  cards,
  onCardClick,
  handleAddSubscription,
  getButtonTitle,
  onTitleClick,
  loadingIds,
  renderLastCard,
  buttonIconColor = colors.primary.base
}: BenefitsCarouselProps) => {
  return (
    <div className="mx-6 overflow-hidden">
      <button
        aria-label={title}
        className="cursor-pointer"
        {...(onTitleClick && {onClick: onTitleClick})}
      >
        <h3 className="mb-4 text-2xl font-bold">{title}</h3>
      </button>
      <Carousel
        cardWrapperClassname="!w-[246px] box-content p-0"
        renderLastCard={renderLastCard}
        renderCard={card => (
          <CategoryCard
            image={card.logo as string}
            title={card.name}
            subtitle={card.subtitle}
            width="100%"
            isLoading={loadingIds?.includes(card.id)}
            description={card.description}
            icon={
              card?.is_request_sent || card?.is_subscribed ? (
                <CheckIcon />
              ) : (
                <Plus />
              )
            }
            buttonTitle={getButtonTitle(
              !!card?.is_request_sent,
              !!card?.is_subscribed
            )}
            toggled={card?.is_request_sent || card?.is_subscribed}
            onButtonClick={handleAddSubscription(card)}
            {...(onCardClick && {onClick: () => onCardClick(card.id)})}
          />
        )}
        cards={cards}
        buttonIconColor={buttonIconColor}
      />
    </div>
  );
};

export {BenefitsCarousel};
export type {BenefitsCarouselProps, BenefitsCarouselCard};
